/* istanbul ignore file */
import styled, { createGlobalStyle, css } from 'styled-components';
import { colors, zindex, font } from '@chegg-ui/theme';
import { ValidationManager } from '@chegg/commerce-utils';
import { Checkbox } from '@chegg-ui/checkbox';
var CCFIELDS = ValidationManager.types.CCFIELDS;
var getBorderBottomStyle = function getBorderBottomStyle(error) {
  return error ? colors.red700 : colors.grey700;
};
var commonInputStyles = css(["padding:2rem 0px calc(-2px + 0.5rem);width:100%;border:none;font-size:", ";color:", ";font-family:", ";outline:none;box-sizing:content-box;"], font.size.px16, colors.dark, font.family.aspira);
export var InputWrapper = styled.input.withConfig({
  componentId: "sc-hn04it-0"
})(["", " & ~ div{z-index:", ";}border-bottom:1px solid ", ";"], commonInputStyles, zindex.layout, function (_ref) {
  var error = _ref.error;
  return getBorderBottomStyle(error);
});
export var GlobalStyle = createGlobalStyle([".recurly-element{", " border-bottom:1px solid ", ";height:18.5px;}.recurly-element-number{border-bottom:1px solid ", ";}.recurly-element-month{border-bottom:1px solid ", ";}.recurly-element-year{border-bottom:1px solid ", ";}.recurly-element-cvv{border-bottom:1px solid ", ";}"], commonInputStyles, colors.grey700, function (_ref2) {
  var formFields = _ref2.formFields;
  return getBorderBottomStyle(formFields[CCFIELDS.CARD_NUMBER].error);
}, function (_ref3) {
  var formFields = _ref3.formFields;
  return getBorderBottomStyle(formFields[CCFIELDS.EXPIRATION_MONTH].error);
}, function (_ref4) {
  var formFields = _ref4.formFields;
  return getBorderBottomStyle(formFields[CCFIELDS.EXPIRATION_YEAR].error);
}, function (_ref5) {
  var formFields = _ref5.formFields;
  return getBorderBottomStyle(formFields[CCFIELDS.CVV].error);
});
export var CheckboxWrapper = styled(Checkbox).withConfig({
  componentId: "sc-hn04it-1"
})(["padding-top:16px;> svg{padding-right:0;width:auto;}"]);
export var CVVInputWrapper = styled.div.withConfig({
  componentId: "sc-hn04it-2"
})(["& ~ div{z-index:", ";}"], zindex.layout);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/Recurly/styled.js
// module id = 1513
// module chunks = 11